<template>
	<div class="page mygroup_page">
		<div class="w1240" v-if="typeindex==0">
			<div class="block30"></div>
			<div class="mygroup_typebox">
				<div class="line"></div>
				<div class="text fontsize32">我的社团</div>
			</div>
			<div class="dataListbox">
				<div class="itemobj" :class="getRowClass(index)" v-for="(item,index) in dataList" :key="index"
					@click="handledetail(item)">
					<div class="groupname clamp fontsize16">{{item.title}}</div>
					<div class="groupcon clamp fontsize20">{{item.discription}}</div>
					<div class="grouptime fontsize14">{{$util.replaceTspli(item.createDate)}}</div>
				</div>
			</div>
			<div class="dataListbox" v-if="dataList.length<=0">
				<div class="nolist">你暂未加入学习社团，请联系教师邀请加入！</div>
			</div>
		</div>
		<div class="w1200" v-if="typeindex==1">
			<div class="back_typebox" @click="handletype(0)">
				<img class="icon" src="../assets/static/leftgo.png" />
				<div class="text fontsize16">返回社团</div>
			</div>
			<div class="group_detailbox">
				<div class="leftbox">
					<div class="box1">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">{{dataobj.title}}</div>
						</div>
						<div class="textbox">
							<div class="text1 fontsize14">社团描述</div>
							<div class="text2 fontsize16">{{dataobj.discription}}</div>
						</div>
						<div class="textbox">
							<div class="text1 fontsize14">社团分类</div>
							<div class="text2 fontsize16">
								<el-tag :key="tag" v-for="tag in infoTags">
									{{tagFormat(tag)}}
								</el-tag>
							</div>
						</div>
						<div class="textbox">
							<div class="text1 fontsize14">社团组建时间</div>
							<div class="text2 fontsize16">{{$util.replaceTspli(dataobj.createDate)}}</div>
						</div>
					</div>
					<div class="block20"></div>
					<div class="box1">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">通知栏</div>
							<div style="margin-left: auto;">
								<el-button v-if="userInfo.userType===1" type="primary" size="mini" @click="handleeditTongzhi">编辑</el-button>
							</div>
						</div>
						<div class="textbox">
							<!-- <div class="text1 fontsize14"></div> -->
							<div class="text2 fontsize16" style="white-space: pre-wrap;">
								{{dataobj.discription2 || "暂无通知"}}
							</div>
						</div>
					</div>
					<div class="block20"></div>
					<!-- <div class="box1">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">社团成员</div>
						</div>
						<div class="textbox1">
							<div class="text1 fontsize14">名字</div>
							<div class="text2 fontsize14">加入时间</div>
						</div>
						<div class="textbox2" v-for="(item,index) in groupmenber" :key="index" v-if="item.nikename">
							<div class="text1 fontsize14">{{item.hlUser.nikename}}</div>
							<div class="text2 fontsize14">{{$util.replaceTspli(item.createDate)}}</div>
						</div>
					</div> -->
				</div>
				<div class="rightbox">
					<div class="w100 flexrow flexbetween">
						<div class="typebox">
							<div class="line"></div>
							<div class="text fontsize20">作业/竞赛</div>
						</div>
						<div class="addbtn flexrow flexbetween" v-if="userInfo.userType===1">
							<el-button type="warning" size="small" @click="invitefuc">绑定成员</el-button>
							<el-button type="success" size="small" @click="handledexportall">导出汇总成绩</el-button>
							<el-button type="primary" size="small" @click="handledetailClick">发布作业</el-button>
						</div>
					</div>

					<div class="itemobj fontsize14">
						<div class="text1">标题</div>
						<div class="text2">状态</div>
						<div class="text3">开始时间</div>
						<div class="text4">计分结束时间</div>
						<div class="text5"></div>
					</div>
					<div class="itemobj1 fontsize14" v-for="(item,index) in zuoyeList" :key="index">
						<div class="text1">{{item.title}}</div>
						<div class="text2">
							<span class="c1" v-if="item.typeTag=='ing'">进行中</span>
							<span class="c2" v-if="item.typeTag=='end'">已结束</span>
							<span class="c3" v-if="item.typeTag=='before'">未开始</span>
							<span class="c2" v-if="item.typeTag=='on'">补做中</span>
						</div>
						<div class="text3">{{item.examStartTime}}</div>
						<div class="text4">{{item.scoreEndTime}}</div>
						<div class="text6" v-if="userInfo.userType===1">
							<el-dropdown @command="(command) => handleCommandGroup(command, item)">
							  <el-button type="primary" size="mini">
							    编辑操作<i class="el-icon-arrow-down el-icon--right"></i>
							  </el-button>
							  <el-dropdown-menu slot="dropdown">
							    <el-dropdown-item command="check">查看详情</el-dropdown-item>
							    <el-dropdown-item command="edit">编辑作业</el-dropdown-item>
							    <el-dropdown-item command="copy">复制作业</el-dropdown-item>
								<el-dropdown-item command="del">删除作业</el-dropdown-item>
							  </el-dropdown-menu>
							</el-dropdown>
						</div>
						<div class="text5" v-if="userInfo.userType===0" @click="handleworkDetail(item.id)">查看详情</div>
					</div>
					<div style="text-align: right; margin-top: 20px">
						<el-pagination
							background
							:current-page="paginationzuoye.currentPage"
							:page-size="paginationzuoye.pageSize"
							layout="prev, pager, next"
							:total="paginationzuoye.total"
							@current-change="handleCurrentChangezuoye"
						/>
					</div>
				</div>
			</div>
			<!-- 学生课程表 -->
			<div style="width: 100%;margin-top: 18px;" v-if="userInfo.userType===0&&dataobj.schedulerUrl">
				<img class="schedulerUrl" style="width: 100%;height: auto;" :src="dataobj.schedulerUrl" />
			</div>
			<!-- 课时 -->
			<div class="block30" v-if="userInfo.userType===1"></div>
			<div class="class_stu_box" v-if="userInfo.userType===1">
				<div class="stu_box">
					<div class="itemtop fontsize14">
						<div class="item item1">序号</div>
						<div class="item item2">学生名字</div>
						<div class="item item3">当前阶段</div>
						<div class="item item4">剩余课时</div>
						<div class="item item5">上课状态</div>
						<div class="item item6">信息录入</div>
					</div>
					<div class="itemtop fontsize14 itemobj" v-for="(item,index) in stuClassList" :key="index">
						<div class="item item1">{{index+1}}</div>
						<div class="item item2">{{item.hlUser?item.hlUser.nikename :"匿名"}}</div>
						<div class="item item3">{{item.hlUserCourseHours?item.hlUserCourseHours.hoursStage :"暂无"}}</div>
						<div class="item item4">
							{{item.hlUserCourseHours?item.hlUserCourseHours.afterRemainingHours :"暂无"}}
						</div>
						<div class="item item5">
							<div class="text text1" :class="{'text11':item.flowType==0}"
								@click="handleflowType(index,0)">正常</div>
							<div class="text text3" :class="{'text33':item.flowType==1}"
								@click="handleflowType(index,1)">免费</div>
							<div class="text text4" :class="{'text44':item.flowType==2}"
								@click="handleflowType(index,2)">缺课</div>
						</div>
						<div class="item item6">
							<div class="text text1" @click="handlebuke(item)">补课</div>
							<div class="text text2" @click="handleluru(index,item)">录入信息</div>
						</div>
					</div>
				</div>
				<div class="classopen">
					<div>
						<div class="text1 fontsize16">任课老师：{{userInfo.nikename}}</div>
						<div class="text1 fontsize16">最近上课时间：{{bskobj.upClassTime || bskobj.createDate || "无"}}</div>
					</div>
					<div class="flexrow">
						<div class="text3 fontsize16" @click="addclassshow = true">补上课</div>
						<div class="text2 fontsize16" @click="handleopenclass">开始上课</div>
					</div>
				</div>
			</div>

		</div>
		<div class="block30"></div>
		<el-dialog :title="formObj.nikename+'同学的信息录入'" :visible.sync="dialogVisible" width="858px" top="3vh" :close-on-click-modal="false">
			<el-form label-position="top">
				<div class="w100 flexrow flexbetween">
					<div style="width: 48%;">
						<el-form-item label="学生年龄(岁)">
							<el-input v-model="formObj.age" type="number" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
					<div style="width: 48%;">
						<el-form-item label="在读状态">
							<el-select v-model="formObj.studyingStatus" placeholder="请选择">
								<el-option v-for="(item,index) in studyingStatusList" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
				</div>
				<div class="w100 flexrow flexbetween">
					<div style="width: 48%;">
						<el-form-item label="学校">
							<el-input v-model="formObj.school" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
					<div style="width: 48%;">
						<el-form-item label="年级">
							<el-input v-model="formObj.grade" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
				</div>
				<div class="w100 flexrow flexbetween">
					<div style="width: 48%;">
						<el-form-item label="学生资质">
							<el-input v-model="formObj.qualification" type="number" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
					<div style="width: 48%;">
						<el-form-item label="学生能力阶段">
							<el-input v-model="formObj.abilityStage" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
				</div>
				<div class="w100 flexrow flexbetween">
					<div style="width: 48%;">
						<el-form-item label="竞赛情况">
							<el-input v-model="formObj.competitionInfo" type="textarea" :rows="4"
								placeholder="请输入"></el-input>
						</el-form-item>
					</div>
					<div style="width: 48%;">
						<el-form-item label="教师评价">
							<el-input v-model="formObj.teacherEvaluation" type="textarea" :rows="4"
								placeholder="请输入"></el-input>
						</el-form-item>
					</div>
				</div>
				<div class="w100 flexrow flexbetween">
					<div style="width: 48%;">
						<el-form-item label="学生状态">
							<el-input v-model="formObj.classDesc" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
					<div style="width: 48%;">
						<el-form-item label="续课描述">
							<el-input v-model="formObj.studentStatus" placeholder="请输入"></el-input>
						</el-form-item>
					</div>
				</div>


			</el-form>
			<div style="text-align: center; margin-top: 20px">
				<el-button type="primary" @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="onsubmitluru">确定录入</el-button>
			</div>
		</el-dialog>
		<!--随堂作业-->
		<el-dialog title="作业/竞赛" width="58%" top="5vh" :visible.sync="classzuoyeshow" :close-on-click-modal="false">
			<el-form ref="zyssobj" :model="zyssobj" :rules="zyssrules" :label-width="formLabelWidth">
				<el-form-item label="标题" prop="title">
					<el-input v-model="zyssobj.title" placeholder="请填写" />
				</el-form-item>
				<el-form-item label="作业开始时间" prop="examStartTime">
					<el-date-picker v-model="zyssobj.examStartTime" type="datetime" placeholder="开始日期"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
				</el-form-item>
				<el-form-item label="作业结束时间" prop="examEndTime">
					<el-date-picker v-model="zyssobj.examEndTime" type="datetime" placeholder="结束时间"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
				</el-form-item>
				<el-form-item label="分数计算结束时间" prop="scoreEndTime">
					<el-date-picker v-model="zyssobj.scoreEndTime" type="datetime" placeholder="结束时间"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
				</el-form-item>
				<el-form-item label="标签/类型">
					<el-input v-model="zyssobj.infoTags" placeholder="请输入,多个使用'#'号相连,例如:标签1#标签2" />
				</el-form-item>
				<el-form-item label="作业/题目" prop="title">
					<div v-for="(titem,tindex) in questNoList" :key="tindex" class="contendiv">
						<div class="conobj">
							<div class="textname">选择作业-{{ tindex+1 }}</div>
							<el-select :filter-method="(value) => filterMethod1(value, tindex)" v-model="titem.questNo"
								filterable placeholder="请选择作业,可输入关键词搜索" style="width: 100%;"
								@change="selChange($event,tindex)">
								<el-option v-for="(item, index) in titem.options" :key="item.questNo"
									:label="item.questNumber+'--'+item.title" :value="item.questNo" />
							</el-select>
							<div class="el-icon-circle-close" style="font-size: 28px;margin-left: 8px;cursor: pointer;"
								@click="delzuoye(tindex)" />
						</div>
					</div>
					<div class="contendiv"><el-button @click="handaddzuoye()">添加作业</el-button></div>
				</el-form-item>
				<el-form-item style="text-align: center; margin-top: 20px">
					<el-button @click="classzuoyeshow=false">取消</el-button>
					<el-button type="primary" v-if="!zyssobj.id" @click="saveclasszuoye('zyssobj')">确认保存</el-button>
					<el-button type="primary" v-if="zyssobj.id" @click="saveclasszuoye('zyssobj')">确认修改</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--补上课-->
		<el-dialog title="补上课" width="58%" top="5vh" :visible.sync="addclassshow" :close-on-click-modal="false">
			<el-form :label-width="formLabelWidth">
				<el-form-item label="上课时间" prop="examStartTime">
					<el-date-picker v-model="upClassTime" type="datetime" placeholder="开始日期"
						format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" />
				</el-form-item>
				<el-form-item style="text-align: center; margin-top: 20px">
					<el-button @click="addclassshow = false">取消</el-button>
					<el-button type="primary" :loading="loadingLock" @click="handleaddclass()">确认补上课</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--复制作业到指定小组-->
		<el-dialog title="复制作业到指定小组" :visible.sync="copyzyshow" top="8vh" width="58%" :close-on-click-modal="false">
			<el-form ref="zyssobj" :model="copyzyobj" :label-width="formLabelWidth">
				<el-form-item label="复制作业" prop="title">
					<el-input v-model="copyzyobj.title" placeholder="请填写" disabled/>
				</el-form-item>
				<el-form-item label="到小组" prop="userGroup">
					<el-select v-model="copyzyobj.userGroup"><el-option v-for="(item, index) in hlUserGroupList" :key="index" :label="item.title" :value="item.id" /></el-select>
				</el-form-item>
				<el-form-item style="text-align: center; margin-top: 20px">
					<el-button @click="copyzyshow=false">取消</el-button>
					<el-button type="primary" @click="handlecopyzy('copyzyobj')">确认复制</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--  通知栏修改    -->
		<el-dialog title="通知栏修改" :visible.sync="tongzhiObj.ifshow">
			<el-form ref="form" :model="tongzhiObj" :label-width="formLabelWidth">
				<el-form-item label="描述通知栏" prop="discription2">
					<el-input v-model="tongzhiObj.discription2" placeholder="请输入描述" type="textarea" :rows="8" />
				</el-form-item>
				<el-form-item style="text-align: center; margin-top: 20px">
					<el-button type="primary" @click="ontongzhiSubmit('tongzhiObj')">确认修改</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!--邀请用户 -->
		<el-dialog title="邀请用户" width="68%" :visible.sync="dialogsendUser" top="1vh">
			<el-alert title="把需要邀请的用户加入到右边的框中，点击确定即可绑定用户到小组中。" type="warning" />
			<div class="tbmg20" />
			<el-form :label-width="formLabelWidth">
				<el-form-item label="邀请用户">
					<el-transfer
						v-model="inviteList"
						filterable
						:titles="['可邀用户', '小组成员']"
						:button-texts="['取消选择', '确认选择']"
						:data="userList">
						<span slot-scope="{ option }">
						    <el-tooltip class="item" effect="dark" :content="option.label" placement="top" >
						      <span>{{ option.label }}</span>
						    </el-tooltip>
						</span>
					</el-transfer>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" style="text-align: center;">
				<el-button @click="dialogsendUser = false">取 消</el-button>
				<el-button type="primary" @click="handlesendUser">确 定 绑 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		showLoading,
		hideLoading
	} from '@/common/loading.js';
	export default {
		data() {
			return {
				formLabelWidth: "138px",
				typeindex: 0, //0是小 1是详情
				dataList: [], //社团
				typeList: [], //社团类型
				dataobj: {}, //社团对象
				infoTags: [], //社团类型
				groupmenber: [], //社团成员
				zuoyeList: [], //作业
				stuClassList: [], //上课详情
				formObj: {
					abilityStage: "",
					competitionInfo: "",
					qualification: "",
					teacherEvaluation: "",
					userUuid: "",
					index: 0,
					grade: "", //年年级
					age: "",
					school: "",
					nikename:"",
					studyingStatus: "",
					classDesc:"",
					studentStatus:"",
				},
				dialogVisible: false, //信息录入
				studyingStatusList: ["在读", "暂停", "跟班", "试读"], //在读状态
				zyssobj: {
					id: null, //id
					title: "",
					testType: 1, //	测试类型 0比赛 1作业
					questObj: 0, //	测试对象 0所有人 1vip
					examEndTime: "2099-12-31 00:00:00", //赛事结束时间
					examStartTime: "", //赛事结束时间
					infoTags: "",
				}, //作业赛事对象
				classzuoyeshow: false,
				questNoList: [], //作业
				allquestList: [], //全部题目
				zyssrules: {
					title: [{
						required: true,
						message: '请输入',
						trigger: 'change'
					}],
					examEndTime: [{
						required: true,
						message: '请输入',
						trigger: 'change'
					}],
					examStartTime: [{
						required: true,
						message: '请输入',
						trigger: 'change'
					}],
					scoreEndTime: [{
						required: true,
						message: '请输入',
						trigger: 'change'
					}],
					infoTags: [{
						required: true,
						message: '请输入',
						trigger: 'change'
					}],
				},
				paginationzuoye:{
					currentPage:1,//第一页
					pageSize:10,
					total:0,
				},
				upClassTime:"",//上课时间
				addclassshow:false,//补上课弹窗
				bskobj:{
					upClassTime:"",
					createDate:""
				},
				copyzyshow:false,//复制作业
				hlUserGroupList:[],//小组列表v
				copyzyobj:{
					id:"",
					title:"",
					userGroup:"",//小组ID
				},
				loadingLock:false,//请求锁，false可以请求，true等待
				tongzhiObj:{
					id:"",
					discription2:"",
					ifshow:false
				},
				oriuserList: [],
				userList: [],
				dialogsendUser: false,
				inviteList:[],//邀请成员
			};
		},
		mounted: function() {

		},
		activated() {
			if (this.typeindex == 0 && this.dataList.length <= 0) {
				//获取我的社团类型
				this.getmyGrouptype()
			}
			if(this.userInfo.userType===1){
				//用户列表
				this.getuserList()
			}
		},
		computed: {
			...mapState(['userInfo', 'isLogin', 'sysRole']),
		},
		methods: {
			//确认绑定
			handlesendUser(){
				var _this = this
				if(this.inviteList.length<=0){
				    this.$message.error("请选择用户")
					return;
				}
				var list = []
				for(var i=0;i<=this.inviteList.length;i++){
					if(this.inviteList[i]){
						list.push({
							userUuid:this.inviteList[i],
							groupId:this.dataobj.id
						})
					}
				}
				var params = {
					groupId:this.dataobj.id,
					hlUserGroupMemberList:list
				}
				_this.$http.post('app/hlexam/teacherHlQuestExam/saveList', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.$message({
							type: 'success',
							message: '成功!'
						});
						_this.dialogsendUser = false;
						//成员分页列表
						_this.getmyGroupStuClass()
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//邀请成员
			invitefuc(){
				var _this = this
				if(this.dataobj.id){
					var params = {
						currentPage: 1,
						pageSize: 88888,
						groupId:this.dataobj.id
					};
					_this.$http.post('app/hlexam/hlUserGroupMember/index2', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							var list = res.data.records;
							var data = []
							list.forEach((item, index) => {
								data.push(item.userUuid);
							});
							_this.inviteList = data
							_this.dialogsendUser = true
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}else{
					this.$message.error("uid参数丢失，请返回")
				}
			},
			//用户列表
			getuserList() {
				var _this = this
				var params = {
					currentPage: 1,
					pageSize: 88888,
				};
				_this.$http.post('app/hlexam/teacherHlQuestExam/userIndex', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.inviteList = [];
						_this.oriuserList = res.data.records;
						_this.userList = _this.generateData(res.data.records);
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			// 处理穿梭框的数据
			generateData(list) {
				var data = [];
				if (list && list.length > 0) {
					list.forEach((item, index) => {
						data.push({
							label:item.name + '-' + item.nikename + '-' + item.phone + '('+(item.level==1?'会员':'')+')',
							value: item.uuid,
							key: item.uuid,
							id: item.uuid
						});
					});
					return data;
				}
			},
			//修改通知栏
			handleeditTongzhi(){
				this.tongzhiObj.id = this.dataobj.id
				this.tongzhiObj.ifshow = true
				this.tongzhiObj.discription2 = this.dataobj.discription2
			},
			ontongzhiSubmit(){
				var _this = this
				if(!this.tongzhiObj.discription2){
					this.$message.error('请输入通知栏信息');
					return false;
				}
				var params = this.tongzhiObj
				_this.$http.post('app/hlexam/teacherHlQuestExam/editDiscription2', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.$message.success('修改成功');
						_this.tongzhiObj.ifshow = false
						_this.dataobj.discription2 = _this.tongzhiObj.discription2
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//作业选项操作
			handleCommandGroup(command,row) {
				//console.log(command,row)
				var _this = this
			    if(command=="edit"){
					//编辑
					this.zyssobj = row
					if(row.questNoList){
						row.questNoList.forEach((item, index) => {
							item["options"] = this.allquestList.filter(sitem => sitem.questNo.indexOf(item.questNo) > -1).slice(0, 10);
						});
						this.questNoList = row.questNoList
					}else{
						this.questNoList = []
					}
					this.classzuoyeshow = true
				}else if(command=="copy"){
					//复制
					this.copyzyobj.id = row.id
					this.copyzyobj.title = row.title
					this.copyzyshow = true
					//小组列表
					this.hlUserGroupList = this.dataList
				}else if(command=="del"){
					//删除
					_this.$confirm("确定要删除作业-"+row.title, '提示', {
						confirmButtonText: '确定删除',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						var params = {
							ids:[row.id],
							param:"delete"
						}
						_this.$http.post('app/hlexam/teacherHlQuestExam/status', params).then(function(res) {
							//数据处理
							if (res.code == 200) {
								_this.$message.success('删除成功！');
								_this.handlezuoyeList()
							} else {
								_this.$confirm(res.message, '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {}).catch(() => {});
							}
						})
					}).catch(() => {});
				}else{
					this.handleworkDetail(row.id)
				}
			},
			//复制作业
			handlecopyzy(){
				var _this = this
				if(!this.copyzyobj.userGroup){
					this.$message.error('请选择小组');
					return false;
				}
				var params = this.copyzyobj
				_this.$http.post('app/hlexam/teacherHlQuestExam/copySave', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.$message.success('复制成功');
						_this.copyzyshow = false
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//最近上课时间
			getnearClassTime() {
				var _this = this
				var params = {
					groupId: _this.dataobj.id,
					userUuid: _this.userInfo.uuid,
				}
				_this.$http.post('app/hlexam/hlUserGroup/nearClassTime', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						if(res.data){
							_this.bskobj = res.data
						}else{
							//没有返回，初始化空值
							_this.bskobj = {
								upClassTime:"",
								createDate:""
							}
						}
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//补上课
			handleaddclass(){
				var _this = this
				//加锁
				if(_this.loadingLock){
					//有锁返回
					return;
				}
				_this.loadingLock = true
				//加锁
				if(!this.upClassTime){
					this.$message.error('请输入上课时间')
					return false;
				}
				var params = {
					groupId: _this.dataobj.id,
					userUuid: _this.userInfo.uuid,
					upClassTime:_this.upClassTime,
					detailList: []
				}
				var stuClassList = _this.stuClassList
				for (var i = 0; i < stuClassList.length; i++) {
					params.detailList.push({
						flowType: stuClassList[i].flowType,
						userUuid: stuClassList[i].userUuid
					})
				}
				_this.$http.post('app/hlexam/hlUserGroup/upClassNew', params).then(function(res) {
					//解开锁
					_this.loadingLock = false
					//数据处理
					if (res.code == 200) {
						_this.addclassshow = false
						_this.$message.success("补上课成功！")
						_this.stuClassList.forEach((item, index) => {
							item["flowType"] = 0 //上课类型 0正常 1免费 2缺课 3补课
							item["ifclass"] = false //是否补课
						});
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//保存作业
			saveclasszuoye(form){
				var _this = this
				if(this.questNoList.length<=0){
					this.$message.error('至少添加一个作业')
					return false;
				}
				this.$refs[form].validate(valid => {
					if (valid) {
						var data = _this.zyssobj
						data["questNoList"] = _this.questNoList
						data["userGroup"] = _this.dataobj.id
						if(data.id){
							_this.$http.post('app/hlexam/teacherHlQuestExam/edit', data).then(function(res) {
								_this.$message.success('修改成功')
								_this.classzuoyeshow = false
								_this.handlezuoyeList()
							})
						}else{
							_this.$http.post('app/hlexam/teacherHlQuestExam/save', data).then(function(res) {
								_this.$message.success('保存成功')
								_this.classzuoyeshow = false
								_this.handlezuoyeList()
							})
						}
					} else {
						this.$message.error('请填写必填数据')
						return false
					}
				})
			},
			//全部题目
			getallquestList() {
				var _this = this
				var params = {}
				_this.$http.post('app/hlexam/teacherHlQuestExam/index2', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.allquestList = res.data
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//导出成功
			handledexportall() {
				var _this = this
				//此处接口调用处理等
				var data = {
					id: this.dataobj.id
				}
				showLoading('加载中...')
				_this.$message({
					type: 'info',
					message: '导出可能时间长，切勿多次点击！'
				});
				_this.$api.postJsonexcel('hlexam/hlQuestExam/groupExamUserSumList', data, res => {
					hideLoading()
					const blob = new Blob([res]);
					const fileName = _this.dataobj.title + '-小组汇总成绩.xls';
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
					_this.$message({
						type: 'success',
						message: '导出完毕!'
					});
				})
			},
			// 格式化日期为 YYYY-MM-DD HH:MM:SS
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');

				return `${year}-${month}-${day} 00:00:00`;
			},
			// 获取当天0点
			getTodayStart() {
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				return today;
			},
			// 获取7天后的0点
			getNextWeekStart() {
				const nextWeek = new Date();
				nextWeek.setDate(nextWeek.getDate() + 7);
				nextWeek.setHours(0, 0, 0, 0);
				return nextWeek;
			},
			// 增加作业
			handaddzuoye() {
				var obj = {
					questNo: null,
					score: '',
					options: [], //选项
				}
				this.questNoList.push(obj)
			},
			// 剔除作业
			delzuoye(index) {
				this.questNoList.splice(index, 1)
			},
			// 选择作业
			selChange(uid, tindex) {
				console.log("selChange", uid)
				// console.log(tindex)
				// var obj = this.allquestList.find((item) => { // 数据源
				// 	return item.id === uid // 筛选出匹配数据
				// })
				// if (obj) {

				// }
			},
			//筛选选项，每次只返回一百个
			filterMethod1(val, index) {
				console.log(val, index)
				if (val) {
					console.log(this.questNoList[index])
					var obj = this.allquestList.find((item) => { // 数据源
						return this.questNoList[index].questNo == item.questNo // 筛选出匹配数据
					})
					console.log(obj)
					var options = this.allquestList.filter(item => (item.title && item.title.indexOf(val) > -1) || (item
						.questNumber && item.questNumber.indexOf(val) > -1)).slice(0, 100);
					if (obj) {
						var findindex = options.findIndex((item) => { // 数据源
							return obj.questNo == item.questNo // 筛选出匹配数据
						})
						if (findindex < 0) {
							options.unshift(obj)
						}
					}
					this.questNoList[index].options = options
					//console.log(this.questNoList[index].options)
					this.$forceUpdate()
				}
			},
			//创建作业
			handledetailClick() {
				//默认时间
				const startDate = this.getTodayStart();
				const endDate = this.getNextWeekStart();
				this.zyssobj = {
						id: null, //id
						title: "",
						testType: 1, //	测试类型 0比赛 1作业
						questObj: 0, //	测试对象 0所有人 1vip
						examEndTime: "2099-12-31 00:00:00", //赛事结束时间
						examStartTime: this.formatDate(startDate), //赛事结束时间
						infoTags: "",
						scoreEndTime: this.formatDate(endDate), //分数计算结束时间
					}, //作业赛事对象
					this.questNoList = []
				this.classzuoyeshow = true
			},
			//开始上课
			handleopenclass() {
				var _this = this
				//老师
				_this.$confirm("点名完成，是否确定上课，扣除上课学生课时。", '提示', {
					confirmButtonText: '确定上课',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var params = {
						groupId: _this.dataobj.id,
						userUuid: _this.userInfo.uuid,
						detailList: []
					}
					var stuClassList = _this.stuClassList
					for (var i = 0; i < stuClassList.length; i++) {
						params.detailList.push({
							flowType: stuClassList[i].flowType,
							userUuid: stuClassList[i].userUuid
						})
					}
					_this.$http.post('app/hlexam/hlUserGroup/upClass', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.$message.success("上课成功！")
							_this.stuClassList.forEach((item, index) => {
								item["flowType"] = 0 //上课类型 0正常 1免费 2缺课 3补课
								item["ifclass"] = false //是否补课
							});
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}).catch(() => {});
			},
			//上课状态
			handleflowType(index, flowType) {
				this.stuClassList[index].flowType = flowType
			},
			//学生录入
			handleluru(index, item) {
				this.dialogVisible = true
				this.formObj = {
					abilityStage: item.hlUser.abilityStage,
					competitionInfo: item.hlUser.competitionInfo,
					qualification: item.hlUser.qualification,
					teacherEvaluation: item.hlUser.teacherEvaluation,
					age: item.hlUser.age,
					grade: item.hlUser.grade,
					school: item.hlUser.school,
					studyingStatus: item.hlUser.studyingStatus,
					userUuid: item.userUuid,
					nikename:item.hlUser.nikename,
					classDesc:item.hlUser.classDesc,
					studentStatus:item.hlUser.studentStatus,
					index: index
				}
			},
			//确认录入
			onsubmitluru() {
				var _this = this
				var params = this.formObj
				try {
					params.qualification = params.qualification ? _this.toFixedTrunc(Number(params.qualification), 1) :
						params.qualification
				} catch (e) {
					console.log(e)
					//TODO handle the exception
				}

				_this.$http.post('app/hlexam/hlUserGroup/putInfo', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.$message.success("录入成功！")
						_this.dialogVisible = false
						Object.assign(_this.stuClassList[_this.formObj.index].hlUser, _this.formObj)
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//处理数点
			toFixedTrunc(num, fixed) {
				// 将数字转换为字符串，以分离整数部分和小数部分
				let numStr = num.toString();
				let parts = numStr.split('.');
				if (parts.length === 1) {
					// 如果没有小数部分，直接返回原数字
					return num;
				}
				// 截取小数部分的前fixed位
				let decimalPart = parts[1].substring(0, fixed);
				// 如果fixed为0，则只返回整数部分
				if (fixed === 0) {
					return parseInt(parts[0], 10);
				}
				// 否则返回整数部分加上截断后的小数部分
				return parseFloat(parts[0] + '.' + decimalPart);
			},
			//补课
			handlebuke(item) {
				var _this = this
				//老师
				_this.$confirm("是否确定为" + item.hlUser.nikename + "学生进行补课 ", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var params = {
						groupId: _this.dataobj.id,
						userUuid: _this.userInfo.uuid,
						detailList: [{
							flowType: 3,
							userUuid: item.userUuid
						}]
					}
					_this.$http.post('app/hlexam/hlUserGroup/upClass', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.$message.success("补课成功！")
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}).catch(() => {});
			},
			//获取社团上课详情学生信息
			getmyGroupStuClass() {
				var _this = this
				//老师
				if (this.userInfo.userType && this.userInfo.userType === 1) {
					var params = {
						groupId: this.dataobj.id
					}
					this.$http.post('app/hlexam/hlUserGroup/memberList', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							res.data.forEach((item, index) => {
								item["flowType"] = 0 //上课类型 0正常 1免费 2缺课 3补课
								item["ifclass"] = false //是否补课
							});
							_this.stuClassList = res.data
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			getmyGroup() {
				var _this = this
				//需要登录
				if (this.isLogin) {
					var params = {
						currentPage: 1,
						pageSize: 8888,
					}
					params["userUuid"] = this.userInfo.uuid
					this.$http.post('app/hlexam/hlUserGroup/myGroup', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.dataList = res.data.records
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			//获取我的社团
			getmyGroup() {
				var _this = this
				//需要登录
				if (this.isLogin) {
					var params = {
						currentPage: 1,
						pageSize: 8888,
					}
					params["userUuid"] = this.userInfo.uuid
					this.$http.post('app/hlexam/hlUserGroup/myGroup', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.dataList = res.data.records
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			//获取我的社团类型
			getmyGrouptype() {
				var _this = this
				//需要登录
				if (this.isLogin) {
					var params = {
						currentPage: 1,
						pageSize: 8888,
					}
					params["userUuid"] = this.userInfo.uuid
					this.$http.post('app/hlexam/hlUserGroupType/index', params).then(function(res) {
						//数据处理
						if (res.code == 200) {
							_this.typeList = res.data.records
							//获取我的社团
							_this.getmyGroup()
						} else {
							_this.$confirm(res.message, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {}).catch(() => {});
						}
					})
				}
			},
			//分页作业
			handleCurrentChangezuoye(currentPage) {
				this.paginationzuoye.currentPage = currentPage;
				//获取分页作业列表
				this.handlezuoyeList()
			},
			//获取我的社团作业
			handlezuoyeList() {
				var _this = this
				//需要登录
				var params = {
					currentPage: this.paginationzuoye.currentPage,
					pageSize: this.paginationzuoye.pageSize,
					testType: 1,
				}
				//params["userUuid"] = this.userInfo.uuid
				params["userGroup"] = this.dataobj.id
				this.$http.post('app/hlexam/hlQuestExam/index', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						//作业状态
						res.data.records.forEach((item, index) => {
							// console.log(row)
							var examStartTime = _this.$util.getDateTime2(item.examStartTime)
							var examEndTime = _this.$util.getDateTime2(item.examEndTime)
							var scoreEndTime = _this.$util.getDateTime2(item.scoreEndTime || item
								.examEndTime)
							try {
								item["typeTag"] = _this.$util.compareTimes2(examStartTime, examEndTime,
									scoreEndTime)
							} catch (e) {
								item["typeTag"] = ""
							}
						});
						_this.zuoyeList = res.data.records
						_this.paginationzuoye.total = res.data.total
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//获取我的社团成员
			hlUserGroupMember() {
				var _this = this
				//需要登录
				var params = {
					currentPage: 1,
					pageSize: 8888,
				}
				params["groupId"] = this.dataobj.id
				this.$http.post('/app/hlexam/hlUserGroupMember/index2', params).then(function(res) {
					//数据处理
					if (res.code == 200) {
						_this.groupmenber = res.data.records
					} else {
						_this.$confirm(res.message, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {}).catch(() => {});
					}
				})
			},
			//颜色
			getRowClass(index) {
				// 根据需要判断第1第2第3第4列的倍数
				const multipleClasses = {
					'1': 'first-column',
					'2': 'second-column',
					'3': 'third-column',
					'4': 'fourth-column'
				};
				let classNames = '';
				Object.keys(multipleClasses).forEach(multiple => {
					if (index % multiple === 0) {
						classNames += ` ${multipleClasses[multiple]}`;
					}
				});
				return classNames.trim();
			},
			//标签
			tagFormat(tag) {
				const obj = this.typeList.find((ifitem) => { //这里的options就是上面遍历的数据源
					return ifitem.id == tag; //筛选出匹配数据
				});
				if (obj) {
					return obj.title
				} else {
					return tag
				}
			},
			//跳转
			handledetail(item) {
				// this.$router.push({
				// 	path: "/class",
				// 	query:{
				// 		uid:uid
				// 	}
				// });
				this.infoTags = []
				try {
					this.infoTags = JSON.parse(item.infoTags)
				} catch (e) {
					//TODO handle the exception
				}
				this.dataobj = item
				this.paginationzuoye.currentPage = 1
				this.handletype(1)
				//获取我的社团作业
				this.handlezuoyeList()
				//获取我的社团成员
				this.hlUserGroupMember()
				//获取社团上课详情学生信息
				this.getmyGroupStuClass()
				//全部题目
				this.getallquestList()
				//最近上课时间
				this.getnearClassTime()
				const h = this.$createElement;
				if(this.userInfo.userType===1){
					this.$alert(h('i', { style: 'color: teal'}, '请老师上课前点击开始上课！'), '点名提醒', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {}).catch(() => {});
				}
				
			},
			//作业赛事详情
			handleworkDetail(uid) {
				this.$router.push({
					path: "/mygroupwork",
					query: {
						uid: uid
					}
				});
			},
			//类型
			handletype(type) {
				this.typeindex = type
			},


		}
	};
</script>
<style lang="scss" scoped>
	.contendiv {
		width: 100%;
		box-sizing: border-box;
		padding: 18px;
		background-color: #f8f8f8;
		border-radius: 8px;
	}

	.contendiv .conobj {
		display: flex;
		align-items: center;
		padding-bottom: 18px;
	}

	.contendiv .conobj .textname {
		width: 98px;
		font-size: 13px;
		color: #333;
	}
</style>